import { Link } from "gatsby"
import React, { useState } from "react"
import { makeStyles, TextField, Hidden } from "@material-ui/core"
import Cookies from "universal-cookie"
// Assets
import { Button, GridDialog, RichDescription, RichTitle } from ".."
import { Typography } from "@material-ui/core"
import { FormattedMessage, injectIntl } from "react-intl"
import "../PopUp/popup.css"
import warning from "../PopUp/warning.png"
import { gateway as MoltinGateway } from "@moltin/sdk"

const styles = makeStyles(theme => {
  return {
    body: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8, 0),
    },
    content: {
      width: "100%",
      maxWidth: theme.spacing(50),
    },
    submitButton: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    title: {
      color: theme.palette.green.main,
      textAlign: "center",
    },
    failureTitle: {
      color: theme.palette.red.main,
      textAlign: "center",
    },
    bodyText: {
      marginBottom: theme.spacing(4),
    },
    successText: {
      textAlign: "center",
      marginBottom: theme.spacing(4),
    },
    leafLeft: {
      position: "absolute",
      left: 0,
      top: "10%",
      width: 80,
      height: 77,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    leafRight: {
      position: "absolute",
      right: 0,
      bottom: "10%",
      width: 80,
      height: 77,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },

    footerContainer: {
      width: "90%",
      maxWidth: "1296px",
      paddingTop: theme.spacing(6),
      marginBottom: "32px",
      marginRight: "auto",
      marginLeft: "auto",
    },
    linkList: {
      listStyle: "none",
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        textAlign: "center",
      },
      width: "60%",
    },
    footerList: {
      listStyle: "none",
      display: "flex",
      width: "90%",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        textAlign: "center",
        marginLeft: theme.spacing(4.375),
      },
    },
    cardList: {
      listStyle: "none",
      display: "flex",
      width: "auto",
      "flex-flow": "row wrap",
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
        justifyContent: "center",
      },
      // [theme.breakpoints.between("md", "lg")]: {
      //   width: "60%",
      // },
      [theme.breakpoints.up("lg")]: {
        justifyContent: "space-between",
      },
    },
    bottomText: {
      textDecoration: "none",
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.tertiary.main,
      fontSize: "14px",
      lineHeight: "20px",
      [theme.breakpoints.down("md")]: {
        marginTop: "16px",
      },
      [theme.breakpoints.up("lg")]: {
        marginRight: "40px",
      },
      [theme.breakpoints.down("lg")]: {
        marginRight: theme.spacing(3.3),
      },
    },

    bottomTextContainer: {
      [theme.breakpoints.up("md")]: {
        textAlign: "center",
      },
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
    footerTextContainer: {
      textAlign: "center",
      [theme.breakpoints.up("lg")]: {
        marginLeft: "72px",
      },
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
    footerTextContainer_1: {
      textAlign: "center",
      [theme.breakpoints.up("lg")]: {
        marginLeft: "0px",
      },
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
    footerText: {
      textDecoration: "none",
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.black.main,
      fontSize: "13px",
      lineHeight: "20px",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
    listContainer: {
      display: "flex",
      flexDirection: "row",

      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
    bottomContainer: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
      },
    },
    cardContainer: {
      [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(2),
      },
      [theme.breakpoints.down("sm")]: {
        marginLeft: theme.spacing(1),
      },
    },
    cardContainer_1: {
      marginLeft: 0,
    },
    cardContainerText: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.black.main,
      fontSize: "13px",
      lineHeight: "20px",
      marginTop: "auto",
      marginBottom: theme.spacing(2),
      display: "block",
      flex: "1 100%",
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
    },
    payuHighlight: {
      color: theme.palette.payu.main,
    },
    cardLogo: {
      maxWidth: theme.spacing(6.75),
      maxHeight: theme.spacing(4.75),
    },
    divLine: {
      height: "1px",
      maxWidth: "1296px",
      marginRight: "auto",
      marginBottom: "32px",
      marginLeft: "auto",
      backgroundColor: theme.palette.black.supportLight,
      width: "100%",
    },
    divLineBottom: {
      marginTop: "32px",
      marginBottom: "32px",
      height: "1px",
      maxWidth: "1296px",
      marginRight: "auto",
      marginLeft: "auto",
      backgroundColor: theme.palette.black.supportLight,
      width: "100%",
    },
    socialContainer: {
      maxWidth: "1296px",
      textAlign: "center",
    },
    social: {
      textAlign: "center",
    },
    socialText: {
      fontFamily: theme.typography.fontFamily,
      marginBottom: theme.spacing(4),
      fontSize: "28px",
      fontWeight: "bold",
    },
    subscribe: {
      margin: theme.spacing(6, 0, 2, 0),
      display: "block",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },

      justifyContent: "center",
      alignItems: "center",
    },
    subscribeText: {
      marginRight: 20,
      fontFamily: theme.typography.fontFamily,
      fontSize: "20px",
      fontWeight: "normal",
    },
    socialIcon: {
      marginLeft: "40px",
    },
    socialIcon_1: {
      paddingLeft: "0px",
    },
    formContainer: {
      borderColor: theme.palette.black.support,
      margin: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "380px",
      },
      height: "48px",
      justifyContent: "space-between",
      paddingTop: "0px",
      paddingBottom: "0px",
      display: "flex",
      alignItems: "center",
    },

    button: theme.typography.button,
    textField: {
      position: "relative",
      borderColor: theme.palette.black.support,
      borderStyle: "solid",
      borderWidth: 1,
      width: "100%",
      height: "100%",
      padding: theme.spacing(1, 0, 0, 2),
    },
    checkContainer: {
      height: "auto",
      justifyContent: "space-between",
      paddingTop: "0px",
      paddingBottom: "30px",
      paddingLeft: "30%",
      paddingRight: "20%",
      display: "flex",
      alignItems: "center",
      width: "100%",
      position: "relative",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "20px",
        paddingRight: "20px",
      },
    },
    checktxt: {
      width: "90%",
      paddingLeft: "45px",
      textAlign: "justify",
      [theme.breakpoints.down("sm")]: {
        textAlign: "left",
        paddingLeft: "33px",
      },
    },
    checkinput: {
      position: "absolute",
      top: "0",
      width: "5%",
    },
    hidden: {
      display: "none",
    },
    warningImg: {
      position: "relative",
      height: "20px",
      width: "20px",
      marginRight: "8px",
      marginLeft: "-13px",
      top: "3px",
    },
    header: {
      textAlign: "center",
      width: "100%",
    },
    headerText: {
      fontFamily: theme.typography.fontFamily,
      marginBottom: "0",
      color: "#9abaae",
      marginTop: "5px",
      fontSize: "56px",
      fontWeight: "bold",
      textTransform: "upperCase",
      [theme.breakpoints.down("sm")]: {
        fontSize: "45px",
      },
    },
    discountText: {
      fontFamily: theme.typography.fontFamily,
      marginBottom: "30px",
      color: "#000",
      textTransform: "upperCase",
      fontSize: "23px",
      marginTop: "0",
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },
  }
})

export default injectIntl(props => {
  const cookies = new Cookies()
  const { intl } = props
  const i18nmessages = intl.messages
  const classes = styles(props)
  const [open, setOpen] = useState(false)
  const [email, setEmail] = useState("")
  const [invalid, setInvalid] = useState(false)
  const [confirmation, setConfirmation] = useState(false)
  const [failure, setFailure] = useState(false)
  const [valid, setValid] = useState(false)
  const [checked, setChecked] = useState(false)
  const [emailUsed, setemailUsed] = useState(false)
  const [err, seterr] = useState(false)

  const Visa = props.data.visaLogo.file.url
  const PayU = props.data.payULogo.file.url
  const MasterCard = props.data.masterCardLogo.file.url
  const AMEX = props.data.amexLogo.file.url
  const Discover = props.data.discoverLogo.file.url
  const Facebook = props.data.facebookLogo.file.url
  const Instagram = props.data.instagramLogo.file.url
  const Youtube = props.data.youTubeLogo.file.url
  const footerMenuItems = props.data.footerMenuItems

  const emailValidation = value => {
    const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(value) ? false : true
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleChange = e => {
    setEmail(e.target.value)
  }

  const handleCheck = () => {
    setChecked(!checked)
  }


  const Moltin = MoltinGateway({
    client_id: process.env.GATSBY_MOLTIN_CLIENT_ID,
    client_secret: process.env.GATSBY_MOLTIN_CLIENT_SECRET,
  })

  const locale = props.intl.locale

  const sendEmail = (email, customerId) => {
    const data = {
      language: (locale === "es" ? "es" : "en"),
      email: email,
      name: "",
      customerId: customerId,
    }
    fetch(
      "https://ickr3dus78.execute-api.us-east-2.amazonaws.com/prod/email/subscription",
      {
        method: "post",
        body: JSON.stringify(data),
      },
    ).then(entry => {
      console.log("email sent ")
    }).catch(error => {
      console.error(error)
    })
  }

  const handleSubmit = () => {
    if (!emailValidation(email)) {
      if (checked) {
        const data = {
          type: "customer",
          name: "New Customer",
          email: email,
          isSubscribed: true,
          isPromoEligible: true,
        }
        Moltin.Customers.Create(data).then(response => {
          sendEmail(email, response.data.id)
          if (err === false) {
            setConfirmation(true)
            setOpen(true)
            setTimeout(() => {
              setEmail("")
              setOpen(false)
            }, 6000)
          }
        }, errorResponse => {
          if (errorResponse.errors) {
            errorResponse.errors.forEach(error => {
                console.log(error)
                if (error.status === 409) {
                  seterr(true)
                  setConfirmation(false)
                  setemailUsed(true)
                  setOpen(true)
                  setTimeout(() => {
                    setEmail("")
                    setOpen(false)
                    setemailUsed(false)
                    seterr(false)
                  }, 6000)
                }
              },
            )
          }
        })
      } else {
        setChecked(false)
        setValid(true)
      }
    } else {
      setConfirmation(false)
      setInvalid(true)
      setOpen(true)
      setTimeout(() => {
        setEmail("")
        setOpen(false)
        setInvalid(false)
      }, 6000)
    }
  }

  return (
    <footer className={classes.footerContainer}>
      <div className={classes.socialContainer}>
        <div className={classes.social}>
          <h3 className={classes.socialText}>
            {props.data.socialMediaTitle && (
              <RichTitle titleText={props.data.socialMediaTitle}/>
            )}
          </h3>

          <div className={classes.social}>
            <a
              href="https://www.facebook.com/puraearth.world/?ref=py_c"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={classes.socialIcon_1}
                src={Facebook}
                alt="Facebook logo"
              />
            </a>
            <a
              href="https://www.youtube.com/channel/UCTBjlI99uX-ULC31wPfp23g?view_as=subscriber"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={classes.socialIcon}
                src={Youtube}
                alt="Youtube logo"
              />
            </a>
            <a
              href="https://www.instagram.com/purahw_latam/?igshid=1r62jjon3504"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={classes.socialIcon}
                src={Instagram}
                alt="Instagram logo"
              />
            </a>
          </div>
        </div>
        <div className={classes.subscribe}>
          <GridDialog
            fullScreen={"sm"}
            xs={8}
            onClose={handleClose}
            open={open}
          >
            <div className={classes.body}>
              <img
                src={props.bgImgLeft}
                className={classes.leafLeft}
                alt={""}
              />
              <img
                src={props.bgImgRight}
                className={classes.leafRight}
                alt={""}
              />
              <div className={classes.content}>
                {confirmation && (
                  <Typography
                    id={props.titleId}
                    variant={"h4"}
                    classes={{ root: classes.title }}
                  >
                    <FormattedMessage id="thanksForSubscribing"/>
                  </Typography>
                )}{" "}
                {failure && (
                  <Typography
                    id={props.titleId}
                    variant={"h4"}
                    classes={{ root: classes.failureTitle }}
                  >
                    <FormattedMessage id="somethingWentWrong"/>
                  </Typography>
                )}
                {invalid && (
                  <Typography
                    id={props.titleId}
                    variant={"h4"}
                    classes={{ root: classes.failureTitle }}
                  >
                    <FormattedMessage id="invalidEmail"/>
                  </Typography>
                )}
                {failure && (
                  <Typography
                    classes={{ root: classes.successText }}
                    variant={"body1"}
                  >
                    <FormattedMessage id="newsletterFailure"/>
                  </Typography>
                )}
                {invalid && (
                  <Typography
                    classes={{ root: classes.successText }}
                    variant={"body1"}
                  >
                    <FormattedMessage id="pleaseEntervalidEmail"/>
                  </Typography>
                )}
                {emailUsed && (
                  <Typography
                    classes={{ root: classes.failureTitle }}
                    variant={"h4"}
                  >
                    <FormattedMessage id="duplicated"/>
                  </Typography>
                )}
                {emailUsed && (
                  <Typography
                    classes={{ root: classes.successText }}
                    variant={"body1"}
                  >
                    <FormattedMessage id="emailUsed"/>
                  </Typography>
                )}
              </div>
            </div>
          </GridDialog>

          <div className={classes.header}>
            <h5 className={classes.headerText}>
              <FormattedMessage id="popupHeader"/>
            </h5>
            <h5 className={classes.discountText}>
              <FormattedMessage id="discountHeader"/>
            </h5>
          </div>

          <div className={classes.formContainer}>

            <FormattedMessage id="emailPlaceholder">
              {msg => (
                <TextField
                  value={email}
                  placeholder={msg}
                  fullWidth={true}
                  className={classes.textField}
                  type="email"
                  onChange={handleChange}
                />
              )
              }
            </FormattedMessage>

            <Button
              className={classes.button}
              color={props.data.newsletterEmail.buttonColor || "green"}
              onClick={handleSubmit}
            >
              {props.data.newsletterEmail.buttonText && (
                <RichTitle titleText={props.data.newsletterEmail.buttonText}/>
              )}
            </Button>
          </div>
        </div>
        <div className={classes.checkContainer}>
          <div className={classes.checkinput}>
            <input type="checkbox" id="check" checked={checked} onChange={handleCheck}/>
            <div className={valid && !checked ? classes.popover : classes.hidden}>
              <div className="popover_content_index">
                <img className={classes.warningImg} src={warning}/><FormattedMessage id="notChecked"/>
              </div>
            </div>
          </div>
          <div className={classes.checktxt}>
            <label htmlFor="checkbox"><FormattedMessage id="checkbox"/></label>
          </div>
        </div>
      </div>
      <div className={classes.divLine}/>
      <div className={classes.listContainer}>
        {footerMenuItems.map((item, i) => (
          <div key={i} className={classes.linkList}>
            <div className={classes.footerTextContainer_1}>
              <Link
                to={`/${props.langKey}/${
                  item.redirectLink ? item.redirectLink : ""
                }`}
                className={classes.footerText}
              >
                {item.titleText && <RichTitle titleText={item.titleText}/>}
              </Link>
            </div>
          </div>
        ))}
      </div>
      <div className={classes.divLineBottom}/>

      <div className={classes.bottomContainer}>
        <div className={classes.footerList}>
          <div className={classes.bottomTextContainer}>
            <Link
              to={`/${props.langKey}/${
                props.data.copyright.redirectLink
                  ? props.data.copyright.redirectLink
                  : ""
              }`}
              className={classes.bottomText}
            >
              ©
              {props.data.copyright.titleText && (
                <RichTitle titleText={props.data.copyright.titleText}/>
              )}
            </Link>
          </div>
          <div className={classes.bottomTextContainer}>
            <Link
              to={"/" + props.langKey + "/terms-of-use"}
              className={classes.bottomText}
            >
              <FormattedMessage id="termsOfUse"/>
            </Link>
          </div>
          <Hidden xsUp>
            <div className={classes.bottomTextContainer}>
              <Link
                to={"/" + props.langKey + "/"}
                className={classes.bottomText}
              >
                <FormattedMessage id="privacyPolicy"/>
              </Link>
            </div>
            <div className={classes.bottomTextContainer}>
              <Link
                to={"/" + props.langKey + "/"}
                className={classes.bottomText}
              >
                <FormattedMessage id="accessibility"/>
              </Link>
            </div>
          </Hidden>
        </div>

        <div className={classes.cardList}>
          <div className={classes.cardContainerText}>
            <FormattedMessage id="securedPayments"/>{" "}
            <span className={classes.payuHighlight}>PayU</span>
          </div>

          <div className={classes.cardContainer_1}>
            <img src={PayU} alt="PayU Logo" className={classes.cardLogo}/>
          </div>
          <div className={classes.cardContainer}>
            <img src={Visa} alt="Visa Logo" className={classes.cardLogo}/>
          </div>
          <div className={classes.cardContainer}>
            <img
              src={MasterCard}
              alt="Mastercard Logo"
              className={classes.cardLogo}
            />
          </div>
          <div className={classes.cardContainer}>
            <img
              src={AMEX}
              alt="American Express Logo"
              className={classes.cardLogo}
            />
          </div>
          <div className={classes.cardContainer}>
            <img
              src={Discover}
              alt="Discover Logo"
              className={classes.cardLogo}
            />
          </div>
        </div>
      </div>
    </footer>
  )
})
